export default __webpack_public_path__ + "static/media/asd-min.8df0c758.jpg";